// extracted by mini-css-extract-plugin
module.exports = {"invoiceInfo":"InvoiceInfo_invoiceInfo__8gYvB","title":"InvoiceInfo_title__1RNKw","divForm":"InvoiceInfo_divForm__2Md76","spacer":"InvoiceInfo_spacer__2quKA"};